import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const BRAND = {
  pink: "#EC008C",
  pinkDeep: "#C4007A",
  pinkSoft: "#FFF0F8",
  green: "#B4D338",
  greenDeep: "#7A9024",
  cream: "#F9F6E9",
  ink: "#171717",
  logoUrl: "https://customer-assets.emergentagent.com/job_commission-compass-1/artifacts/8veujkgw_Avo%20Logo.png",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Diagnostic error extractor for auth flows — distinguishes network / auth / server errors
// so the toast is actually useful rather than the generic "Something went wrong…".
export function extractAuthError(e) {
  // No response at all — network failure, CORS block, or backend restarting
  if (!e || !e.response) {
    return "Can't reach the server. Check your connection and try again in a moment.";
  }
  const { status, data } = e.response;
  // Backend returned a validation / auth message
  if (data && data.detail) {
    const msg = formatApiErrorDetail(data.detail);
    if (msg) return msg;
  }
  if (status === 401 || status === 403) return "Invalid email or password.";
  if (status === 429) return "Too many attempts — please wait a minute and try again.";
  if (status >= 500) return "Server hiccup — please try again in a moment.";
  return e.message || "Something went wrong. Please try again.";
}

export function formatGBP(value) {
  if (value === null || value === undefined || isNaN(value)) return "£0";
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatGBPExact(value) {
  if (value === null || value === undefined || isNaN(value)) return "£0.00";
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

// Simplified 3-stage pipeline aligned with Avocado Property workflow
export const STATUS_STYLES = {
  "Referred":         { bg: "#F5F0EA", text: "#6B5D4E", border: "#E4DBCB" },
  "Confirmed Client": { bg: "#DFF1B7", text: "#4C6812", border: "#B4D338" },
  "Sale Completed":   { bg: "#EC008C", text: "#FFFFFF", border: "#EC008C" },
  "Removed":          { bg: "#FEE2E2", text: "#991B1B", border: "#FCA5A5" },
};
